// @flow
import React, {PureComponent} from 'react'
import {uniqBy, isEmpty} from 'lodash'
import Select from 'react-select'
import I18n from 'I18n'
import {NotificationManager} from 'modules/Common/components/Notification'

import Modal from '../Modal'
import {debounce} from 'lodash'
import 'react-select/dist/react-select.css'
import styles from './AddClientModal.module.scss'
import errorCodeHandle from 'modules/Common/utils/errorCodeHandle'

import type {Props as ParentProps} from './AddClientModal'

export type Props = {
  isShow: boolean,
  handleClose: () => void,
  handleClickButton: Function,
  error?: any,
  companyId?: string,
  companyName?: string,
  isLoadingCompaniesSuggestion: boolean,
  companiesSuggestion: $PropertyType<ParentProps, 'companiesSuggestion'>,
  getCompaniesSuggestion: $PropertyType<ParentProps, 'getCompaniesSuggestion'>,
  isLoadingAccountManagersSuggestion: boolean,
  accountManagersSuggestion: $PropertyType<ParentProps,
    'accountManagersSuggestion'>,
  getAccountManagersSuggestion: $PropertyType<ParentProps,
    'getAccountManagersSuggestion'>
};

type State = {
  name: string,
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  company: string,
  accountManager: string,
  temporaryPassword: string,
  step: string,
  temporaryName: string
};

const I18nLocal = I18n.admin

const stepConstants = {
  inputForm: 'INPUT FORM',
  success: 'SUCCESS'
}

export class AddClientModal extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      company: props.companyId || '',
      accountManager: '',
      temporaryPassword: '',
      step: stepConstants.inputForm,
      temporaryName: ''
    }
  }

  afterOpen = () => {}

  componentWillReceiveProps(nextProps: Props) {
    if (!this.props.companyId && nextProps.companyId) {
      this.setState({
        company: nextProps.companyId || ''
      })
    }
  }

  renderHeader = () => {
    if (this.state.step === stepConstants.inputForm) {
      return <span>{I18nLocal.addClient}</span>
    } else {
      return null
    }
  }

  handleSaveBtnClicked = () => {
    const detail: Object = {
      client: {
        companyId: this.state.company,
        name: this.state.name,
        persona: {
          email: this.state.email,
          mobilePhoneNumber: this.state.phoneNumber,
          officePhoneNumber: this.state.phoneNumber,
          firstName: this.state.firstName,
          lastName: this.state.lastName
        },
        userId: [this.state.accountManager],
        status: 'NEW',
        currency: 'USD'
      },
      password: this.state.temporaryPassword
    }
    this.props.handleClickButton(detail).then(() => {
      const error = this.props.error
      if (!error) {
        this.setState({
          step: stepConstants.success,
          name: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          company: '',
          accountManager: '',
          temporaryPassword: '',
          temporaryName: detail.client.name
        })
      } else {
        NotificationManager.error(errorCodeHandle(error.code, error.message))
      }
    })
  }

  hanldeChange = (value: string, key: string) => {
    let state = {...this.state}
    state[key] = value
    this.setState(state)
  }

  checkIsNotHaveEmptyField = () => {
    let check = true
    Object.keys(this.state).map(key => {
      const value = this.state[key]
      if (value === '' && key !== 'temporaryName') {
        check = false
      }
      return null
    })
    return check
  }

  calculateDataToRender = () => {
    let listSuggestions = []

    if (!isEmpty(this.props.companiesSuggestion)) {
      listSuggestions = this.props.companiesSuggestion.map(item => {
        return {value: item.id, label: item.name}
      })
    }

    let listSuggestionsWithFilledCompany = this.props.companyId
      ? [
        ...listSuggestions,
        {
          value: this.props.companyId,
          label: this.props.companyName
        }
      ]
      : listSuggestions
    listSuggestionsWithFilledCompany = uniqBy(
      listSuggestionsWithFilledCompany,
      'value'
    )

    const listSuggestionsAccountManager = this.props.accountManagersSuggestion.map(
      item => {
        return {value: item.id, label: item.name}
      }
    )

    return {listSuggestionsWithFilledCompany, listSuggestionsAccountManager}
  }

  debounceGetCompaniesSuggestion = debounce((value: string) => {
    if (value !== null && value !== '') {
      this.props.getCompaniesSuggestion(value)
    }
  }, 200)

  debounceGetAccountManagersSuggestion = debounce((value: string) => {
    if (value !== null && value !== '') {
      this.props.getAccountManagersSuggestion(value, this.state.company)
    }
  }, 200)

  renderBodyStepInput = () => {
    const checkIsNotHaveEmptyField = this.checkIsNotHaveEmptyField()
    const {
      listSuggestionsWithFilledCompany,
      listSuggestionsAccountManager
    } = this.calculateDataToRender()

    return (
      <div>
        <div className={styles.form}>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.username}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.username}
              value={this.state.name}
              onChange={e => {
                this.hanldeChange(e.target.value, 'name')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.firstName}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.firstName}
              value={this.state.firstName}
              onChange={e => {
                this.hanldeChange(e.target.value, 'firstName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.lastName}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.lastName}
              value={this.state.lastName}
              onChange={e => {
                this.hanldeChange(e.target.value, 'lastName')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.email}</span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.email}
              value={this.state.email}
              onChange={e => {
                this.hanldeChange(e.target.value, 'email')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>
              {I18nLocal.phoneNumber}
            </span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.phoneNumber}
              value={this.state.phoneNumber}
              onChange={e => {
                e.target.value = e.target.value.replace(/\D/g, '')
                this.hanldeChange(e.target.value, 'phoneNumber')
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>{I18nLocal.company}</span>
            <Select
              clearable={false}
              className={styles['field-input']}
              value={this.state.company}
              placeholder={I18nLocal.company}
              options={listSuggestionsWithFilledCompany}
              isLoading={this.props.isLoadingCompaniesSuggestion}
              onInputChange={this.debounceGetCompaniesSuggestion}
              onChange={e => {
                if (e) {
                  this.hanldeChange(e.value, 'company')
                }
              }}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>
              {I18nLocal.accountManager}
            </span>
            <Select
              clearable={false}
              className={styles['field-input']}
              value={this.state.accountManager}
              placeholder={I18nLocal.accountManager}
              options={listSuggestionsAccountManager}
              isLoading={this.props.isLoadingAccountManagersSuggestion}
              onInputChange={this.debounceGetAccountManagersSuggestion}
              onChange={e => {
                if (e) {
                  this.hanldeChange(e.value, 'accountManager')
                }
              }}
              disabled={!this.state.company}
            />
          </div>
          <div className={styles.input}>
            <span className={styles['field-title']}>
              {I18nLocal.temporaryPassword}
            </span>
            <input
              className={styles['field-input']}
              type='text'
              placeholder={I18nLocal.temporaryPassword}
              value={this.state.temporaryPassword}
              onChange={e => {
                this.hanldeChange(e.target.value, 'temporaryPassword')
              }}
            />
          </div>
        </div>
        <hr />
        <div className={styles.buttons}>
          <div
            onClick={this.props.handleClose}
            className={`${styles.button} ${styles.red}`}
          >
            {I18nLocal.cancel}
          </div>
          <div
            onClick={() => {
              checkIsNotHaveEmptyField && this.handleSaveBtnClicked()
            }}
            className={`${styles.button} ${
              !checkIsNotHaveEmptyField ? styles.inactive : ''
            }`}
          >
            {I18nLocal.save}
          </div>
        </div>
      </div>
    )
  }

  renderBodyStepSuccess = () => {
    return (
      <div className={styles['success-form']}>
        <div className={styles['title']}>{I18nLocal.inviteSent}</div>
        <span>
          {I18nLocal.inviteMessage}{' '}
          <span className={styles.name}>{this.state.temporaryName}</span>
        </span>
        <div onClick={this.props.handleClose} className={styles.button}>
          {I18nLocal.done}
        </div>
      </div>
    )
  }

  render() {
    return (
      <Modal
        handleClose={this.props.handleClose}
        isShow={this.props.isShow}
        renderHeader={() => {
          return this.renderHeader()
        }}
        renderBody={() => {
          return this.state.step === stepConstants.inputForm
            ? this.renderBodyStepInput()
            : this.renderBodyStepSuccess()
        }}
        afterOpen={this.afterOpen}
      />
    )
  }
}

export default AddClientModal
